import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { cleanDocumentHTML } from '@ibk/shared-utils';
import styles from './HTMLDocumentModal.module.css';
export const HTMLDocumentModal = ({ htmlContent, isOpen, onClose, title = 'Document', autoClean = true, className = '', closeButtonAriaLabel = 'Close modal', 'data-testid': dataTestId = 'html-document-modal', }) => {
    const dialogRef = useRef(null);
    const processedContent = autoClean ? cleanDocumentHTML(htmlContent) : htmlContent;
    useEffect(() => {
        const dialog = dialogRef.current;
        if (!dialog)
            return;
        const handleEscapeKey = (event) => {
            if (event.key === 'Escape' && isOpen) {
                onClose();
            }
        };
        if (isOpen) {
            if (typeof dialog.showModal === 'function') {
                dialog.showModal();
            }
            else {
                dialog.setAttribute('open', '');
            }
            document.addEventListener('keydown', handleEscapeKey);
            document.body.style.overflow = 'hidden';
        }
        else {
            if (typeof dialog.close === 'function') {
                dialog.close();
            }
            else {
                dialog.removeAttribute('open');
            }
            document.body.style.overflow = '';
        }
        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
            document.body.style.overflow = '';
        };
    }, [isOpen, onClose]);
    const handleBackdropClick = (event) => {
        if (event.target === event.currentTarget) {
            onClose();
        }
    };
    const handleBackdropKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            if (event.target === event.currentTarget) {
                event.preventDefault();
                onClose();
            }
        }
    };
    const handleCloseClick = () => {
        onClose();
    };
    if (!isOpen) {
        return null;
    }
    return (_jsx("dialog", { ref: dialogRef, className: className ?? styles.htmlDocumentModal, "data-testid": `${dataTestId}-dialog`, "aria-labelledby": `${dataTestId}-title`, children: _jsx("div", { className: styles['modal-overlay'], onClick: handleBackdropClick, onKeyDown: handleBackdropKeyDown, tabIndex: 0, role: 'button', "aria-label": closeButtonAriaLabel, "data-testid": `${dataTestId}-overlay`, children: _jsxs("div", { className: styles['modal-container'], "data-testid": `${dataTestId}-container`, children: [_jsxs("header", { className: styles['modal-header'], "data-testid": `${dataTestId}-header`, children: [_jsx("h2", { id: `${dataTestId}-title`, className: styles['modal-title'], "data-testid": `${dataTestId}-title`, children: title }), _jsx("button", { type: 'button', className: styles['close-button'], onClick: handleCloseClick, "aria-label": closeButtonAriaLabel, "data-testid": `${dataTestId}-close-button`, children: "\u00D7" })] }), _jsx("div", { className: styles['document-content'], "data-testid": `${dataTestId}-content`, dangerouslySetInnerHTML: { __html: processedContent } })] }) }) }));
};
